__turbopack_context__.v({
  "fade-in": "CardNoResults-module-scss-module__Wu1Boq__fade-in",
  "root": "CardNoResults-module-scss-module__Wu1Boq__root",
  "text": "CardNoResults-module-scss-module__Wu1Boq__text",
});
